import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PresenterGuard implements CanActivate {
  constructor( private _router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      
      return Auth.currentAuthenticatedUser().then(user => { 
        if (user.signInUserSession.accessToken.payload["cognito:groups"] != undefined){
          var groups = user.signInUserSession.accessToken.payload["cognito:groups"] as Array<string>;
          return groups.includes("Presenter")
        }
        this._router.navigate(['home']);
        return false;
      })
      .catch(() => { 
        this._router.navigate(['home']);
        return false;
      }); 

  }
  
}
